export const API_TIMEOUT = 10000;
export const EMPTY_STRING = '';

export const THEME_URL = '/d3rest/v4/themes/WEB';
export const NEW_ACCOUNT_URL = '/d3rest/v4/nao'
export const NEW_ACCOUNT_STARTUP_URL = NEW_ACCOUNT_URL + '/startup'
export const OPEN_NEW_ACCOUNT_URL = NEW_ACCOUNT_URL + '/open'
